import { z } from 'zod';
import { OrganizationRoles, Organizations, OrganizationInvitations, OrganizationManagementRoles, } from '../db-entries/index.js';
import { organizationManagementPermissionsGuard } from '../foundations/index.js';
import { applicationResponseGuard } from './application.js';
import { userInfoGuard } from './user.js';
export const organizationRoleWithScopesGuard = OrganizationRoles.guard.extend({
    scopes: z
        .object({
        id: z.string(),
        name: z.string(),
    })
        .array(),
    resourceScopes: z
        .object({
        id: z.string(),
        name: z.string(),
        resource: z.object({
            id: z.string(),
            name: z.string(),
        }),
    })
        .array(),
});
const organizationRoleEntityGuard = z.object({
    id: z.string(),
    name: z.string(),
});
export const organizationWithOrganizationRolesGuard = Organizations.guard.extend({
    organizationRoles: organizationRoleEntityGuard.array(),
});
export const userWithOrganizationRolesGuard = userInfoGuard.extend({
    organizationRoles: organizationRoleEntityGuard.array(),
});
export const applicationWithOrganizationRolesGuard = applicationResponseGuard.extend({
    organizationRoles: organizationRoleEntityGuard.array(),
});
export const organizationInvitationEntityGuard = OrganizationInvitations.guard.extend({
    organizationRoles: organizationRoleEntityGuard.array(),
    organizationManagementRoles: organizationRoleEntityGuard.array(),
});
/** Safe organization data and the current member's effective management access. */
export const organizationCenterOrganizationGuard = Organizations.guard
    .pick({
    id: true,
    name: true,
    description: true,
    color: true,
    branding: true,
    customCss: true,
    isMfaRequired: true,
    createdAt: true,
    createdBy: true,
})
    .extend({
    isOwner: z.boolean(),
    permissions: organizationManagementPermissionsGuard,
});
export const organizationManagementRoleResponseGuard = OrganizationManagementRoles.guard;
/** Member fields safe for organization-local administrators. */
export const organizationCenterMemberGuard = userInfoGuard
    .pick({ id: true, name: true, avatar: true, primaryEmail: true, createdAt: true })
    .extend({
    // Optional for clients consuming responses from older self-hosted instances.
    username: userInfoGuard.shape.username.optional(),
    organizationRoles: organizationRoleEntityGuard.array(),
    organizationManagementRoles: organizationRoleEntityGuard
        .extend({
        type: OrganizationManagementRoles.guard.shape.type.optional(),
        description: OrganizationManagementRoles.guard.shape.description.optional(),
    })
        .array(),
    isOwner: z.boolean(),
});
